import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Menu, Popup } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { css } from 'emotion'
import { connect } from "react-redux";
import { homeLinkClicked  } from "../redux/actions/SearchCritriaAction"

function NavItem({
  icon,
  text,
  url,
  minimal,
  ...props
}) {
  return (
    <Menu.Item onClick={() => {clearStoredCriteriaOnHome(props, text)}} className={style}>
      <Link to={url} > 
        {minimal ?
          (<Popup trigger={<Icon name={icon} size='large' />} content={text} inverted position='right center'/>) :
          (<React.Fragment>
            <Icon name={icon} size='large' /> {text}
          </React.Fragment>)
        }
      </Link>
    </Menu.Item>
  )
}

const clearStoredCriteriaOnHome= (props, text) => {
  if(text == "Home")
  {
    props.homeLinkClicked();
  }
}

NavItem.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string.isRequired,
  minimal: PropTypes.bool
}

const style = css`
  & {
    a {
      color: rgba(0,0,0,.7);
    }
    a:hover, a:active {
      color: rgba(0,0,0);
    }
  }
`

export default connect(()=>{}, {homeLinkClicked}) (NavItem);


// WEBPACK FOOTER //
// ./components/nav-panel/NavItem.js